// extracted by mini-css-extract-plugin
export default {"container":"_04_Empty_container__72i22","header":"_04_Empty_header__WZsJP","title":"_04_Empty_title__-k9pR","body":"_04_Empty_body__vd-uI","empty":"_04_Empty_empty__q3PmW"};